/** Ham veri maliyet kataloğu: sarrafiye, gram, hurda, döviz. */

import { findPriceItem, toFiniteNumber } from './financeGoldRate';

export const HAM_CEYREK_YENI = 'CEYREKALTIN';
export const HAM_CEYREK_ESKI = 'CEYREKALTINESKI';
export const HAM_ATA = 'ATA';
export const HAM_GRAM_24 = 'GRAMALTIN';
export const HAM_GRAM_22 = '22AYAR';
export const HAM_HAS = 'ALTINTRY';
export const RESAT_PREMIUM = 1.01;

export const HAM_LABEL = {
  [HAM_CEYREK_ESKI]: 'Çeyrek Altın Eski',
  [HAM_CEYREK_YENI]: 'Çeyrek Altın',
  [HAM_ATA]: 'Ata Altın',
  [HAM_GRAM_24]: 'Gram Altın',
  [HAM_GRAM_22]: '22 Ayar',
  [HAM_HAS]: 'Has Altın',
  USDTRY: 'USD / TRY',
  EURTRY: 'EUR / TRY',
  GBPTRY: 'GBP / TRY',
  CHFTRY: 'CHF / TRY',
  AUDTRY: 'AUD / TRY',
  CADTRY: 'CAD / TRY',
  SARTRY: 'SAR / TRY',
  AEDTRY: 'AED / TRY',
  QARTRY: 'QAR / TRY',
  MADTRY: 'MAD / TRY',
  JODTRY: 'JOD / TRY',
  KWDTRY: 'KWD / TRY',
  CNYTRY: 'CNY / TRY',
  RUBTRY: 'RUB / TRY',
  BGNTRY: 'BGN / TRY'
};

const ZIYNET_MULTIPLIER = {
  ceyrek: 1,
  yarim: 2,
  tam: 4,
  gremse: 10,
  besli: 20
};

export const COST_KIND = {
  COIN: 'coin',
  GRAM: 'gram',
  FX: 'fx',
  MELT: 'melt'
};

export const TAKI_DEFAULT_MILYEM = {
  '22 Ayar Bilezik': 0.916,
  '14 Ayar Bilezik': 0.585,
  '8 Ayar Bilezik': 0.333,
  '22 Ayar Takı': 0.916,
  '21 Ayar Takı': 0.875,
  '18 Ayar Takı': 0.750,
  '14 Ayar Takı': 0.585,
  '8 Ayar Takı': 0.333
};

export const HURDA_DEFAULT_MILYEM = {
  '24 Ayar Hurda': 0.995,
  '22 Ayar Bilezik Hurda': 0.912,
  '22 Ayar Hurda': 0.910,
  '21 Ayar Hurda': 0.850,
  '18 Ayar Hurda': 0.720,
  '14 Ayar Hurda': 0.575,
  '8 Ayar Hurda': 0.310
};

const FX_CODES = {
  'USD - Amerikan Doları': 'USDTRY',
  'EUR - Euro': 'EURTRY',
  'GBP - İngiliz Sterlini': 'GBPTRY',
  'CHF - İsviçre Frangı': 'CHFTRY',
  'AUD - Avustralya Doları': 'AUDTRY',
  'CAD - Kanada Doları': 'CADTRY',
  'SAR - Suudi Arabistan Riyali': 'SARTRY',
  'AED - Birleşik Arap Emirlikleri Dirhemi': 'AEDTRY',
  'QAR - Katar Riyali': 'QARTRY',
  'MAD - Fas Dirhemi': 'MADTRY',
  'JOD - Ürdün Dinarı': 'JODTRY',
  'KWD - Kuveyt Dinarı': 'KWDTRY',
  'CNY - Çin Yuanı': 'CNYTRY',
  'RUB - Rus Rublesi': 'RUBTRY',
  'BGN - Bulgar Levası': 'BGNTRY'
};

export function normalizeProductName(value) {
  return String(value || '')
    .replace(/[''`´]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Sarrafiye: alista da satista da olcut ham SATIS fiyatidir ("toptancidan
 * alsaydik ne oderdik" = yerine konma maliyeti). Iki bacak ayni cetvelle
 * olculdugu icin al-sat toplami her zaman gercek kazanci verir; toptancidan
 * gelen mal sisteme alis olarak girilmedigi halde satista dogru kar cikar.
 * (Karar 2026-09-29: kisa sure ham alis denendi, geri alindi.)
 */
function coin(urun, hamCode, factor, extraFactor, family, rung, formula) {
  return {
    urun,
    kategori: 'Sarrafiye',
    kind: COST_KIND.COIN,
    hamCode,
    factor,
    extraFactor,
    family,
    rung,
    formula,
    quoteMode: 'sell'
  };
}

/** Gram altin da sarrafiye ile ayni cetveli kullanir: iki tarafta ham satis. */
function gram(urun, hamCode, factor, family, formula) {
  return {
    urun,
    kategori: 'Gram Altın',
    kind: COST_KIND.GRAM,
    hamCode,
    factor,
    extraFactor: 1,
    family,
    rung: `${factor} g`,
    formula,
    quoteMode: 'sell'
  };
}

function melt(urun, milyem) {
  return {
    urun,
    kategori: 'Hurda',
    kind: COST_KIND.MELT,
    hamCode: HAM_HAS,
    factor: 1,
    extraFactor: 1,
    milyem,
    family: 'hurda',
    rung: 'bozdurma',
    formula: `Has alış × ${milyem} × gram`,
    quoteMode: 'buy'
  };
}

function fx(urun, hamCode) {
  return {
    urun,
    kategori: 'Döviz',
    kind: COST_KIND.FX,
    hamCode,
    factor: 1,
    extraFactor: 1,
    family: 'fx',
    rung: '1 birim',
    // Kullanici karari 2026-09-29: dovizde alista ham ALIS baz alinir
    // (altin gruplarindan farkli olarak).
    formula: 'Satışta ham satış, alışta ham alış',
    quoteMode: 'side'
  };
}

const SPECS = {
  'Eski Ziynet Çeyrek': coin('Eski Ziynet Çeyrek', HAM_CEYREK_ESKI, ZIYNET_MULTIPLIER.ceyrek, 1, 'eski', 'çeyrek', 'Ham çeyrek eski satış'),
  'Eski Ziynet Yarım': coin('Eski Ziynet Yarım', HAM_CEYREK_ESKI, ZIYNET_MULTIPLIER.yarim, 1, 'eski', 'yarım', 'Eski çeyrek × 2'),
  'Eski Ziynet Tam': coin('Eski Ziynet Tam', HAM_CEYREK_ESKI, ZIYNET_MULTIPLIER.tam, 1, 'eski', 'tam', 'Eski çeyrek × 4'),
  "Eski Ziynet 2.5'lu Gremse": coin("Eski Ziynet 2.5'lu Gremse", HAM_CEYREK_ESKI, ZIYNET_MULTIPLIER.gremse, 1, 'eski', '2.5’lu gremse', 'Eski çeyrek × 10'),
  'Eski Ziynet Beşli': coin('Eski Ziynet Beşli', HAM_CEYREK_ESKI, ZIYNET_MULTIPLIER.besli, 1, 'eski', 'beşli', 'Eski çeyrek × 20'),
  'Yeni Ziynet Çeyrek': coin('Yeni Ziynet Çeyrek', HAM_CEYREK_YENI, ZIYNET_MULTIPLIER.ceyrek, 1, 'yeni', 'çeyrek', 'Ham çeyrek satış'),
  'Yeni Ziynet Yarım': coin('Yeni Ziynet Yarım', HAM_CEYREK_YENI, ZIYNET_MULTIPLIER.yarim, 1, 'yeni', 'yarım', 'Yeni çeyrek × 2'),
  'Yeni Ziynet Tam': coin('Yeni Ziynet Tam', HAM_CEYREK_YENI, ZIYNET_MULTIPLIER.tam, 1, 'yeni', 'tam', 'Yeni çeyrek × 4'),
  "Yeni Ziynet 2.5'lu Gremse": coin("Yeni Ziynet 2.5'lu Gremse", HAM_CEYREK_YENI, ZIYNET_MULTIPLIER.gremse, 1, 'yeni', '2.5’lu gremse', 'Yeni çeyrek × 10'),
  'Yeni Ziynet Beşli': coin('Yeni Ziynet Beşli', HAM_CEYREK_YENI, ZIYNET_MULTIPLIER.besli, 1, 'yeni', 'beşli', 'Yeni çeyrek × 20'),

  'Cumhuriyet Ata': coin('Cumhuriyet Ata', HAM_ATA, 1, 1, 'ata', '1’lik', 'Ham ata satış'),
  'Cumhuriyet Ata Çeyrek': coin('Cumhuriyet Ata Çeyrek', HAM_ATA, 0.25, 1, 'ata', 'çeyrek', 'Ata / 4'),
  'Cumhuriyet Ata Yarım': coin('Cumhuriyet Ata Yarım', HAM_ATA, 0.5, 1, 'ata', 'yarım', 'Ata / 2'),
  "Cumhuriyet Ata 2.5'lu": coin("Cumhuriyet Ata 2.5'lu", HAM_ATA, 2.5, 1, 'ata', '2.5’lu gremse', 'Ata × 2.5'),
  'Cumhuriyet Ata Beşli': coin('Cumhuriyet Ata Beşli', HAM_ATA, 5, 1, 'ata', 'beşli', 'Ata × 5'),

  Reşat: coin('Reşat', HAM_ATA, 1, RESAT_PREMIUM, 'resat', '1’lik', 'Ata satış × 1.01'),
  'Reşat Çeyrek': coin('Reşat Çeyrek', HAM_ATA, 0.25, RESAT_PREMIUM, 'resat', 'çeyrek', 'Reşat / 4'),
  'Reşat Yarım': coin('Reşat Yarım', HAM_ATA, 0.5, RESAT_PREMIUM, 'resat', 'yarım', 'Reşat / 2'),
  "Reşat 2.5'lu": coin("Reşat 2.5'lu", HAM_ATA, 2.5, RESAT_PREMIUM, 'resat', '2.5’lu gremse', 'Reşat × 2.5'),
  'Reşat Beşli': coin('Reşat Beşli', HAM_ATA, 5, RESAT_PREMIUM, 'resat', 'beşli', 'Reşat × 5'),

  '1 Gram 24 Ayar': gram('1 Gram 24 Ayar', HAM_GRAM_24, 1, 'gram24', 'Ham gram altın satış'),
  '0.50 Gram 24 Ayar': gram('0.50 Gram 24 Ayar', HAM_GRAM_24, 0.5, 'gram24', '24 ayar gram × 0.50'),
  '0.25 Gram 24 Ayar': gram('0.25 Gram 24 Ayar', HAM_GRAM_24, 0.25, 'gram24', '24 ayar gram × 0.25'),
  '2.50 Gram 24 Ayar': gram('2.50 Gram 24 Ayar', HAM_GRAM_24, 2.5, 'gram24', '24 ayar gram × 2.50'),
  '5 Gram 24 Ayar': gram('5 Gram 24 Ayar', HAM_GRAM_24, 5, 'gram24', '24 ayar gram × 5'),
  '10 Gram 24 Ayar': gram('10 Gram 24 Ayar', HAM_GRAM_24, 10, 'gram24', '24 ayar gram × 10'),
  '20 Gram 24 Ayar': gram('20 Gram 24 Ayar', HAM_GRAM_24, 20, 'gram24', '24 ayar gram × 20'),
  '50 Gram 24 Ayar': gram('50 Gram 24 Ayar', HAM_GRAM_24, 50, 'gram24', '24 ayar gram × 50'),
  '100 Gram 24 Ayar': gram('100 Gram 24 Ayar', HAM_GRAM_24, 100, 'gram24', '24 ayar gram × 100'),
  '1 Gram 22 Ayar': gram('1 Gram 22 Ayar', HAM_GRAM_22, 1, 'gram22', 'Ham 22 ayar satış'),
  '0.50 Gram 22 Ayar': gram('0.50 Gram 22 Ayar', HAM_GRAM_22, 0.5, 'gram22', '22 ayar gram × 0.50'),
  '0.25 Gram 22 Ayar': gram('0.25 Gram 22 Ayar', HAM_GRAM_22, 0.25, 'gram22', '22 ayar gram × 0.25')
};

Object.keys(HURDA_DEFAULT_MILYEM).forEach((urun) => {
  SPECS[urun] = melt(urun, HURDA_DEFAULT_MILYEM[urun]);
});
Object.entries(FX_CODES).forEach(([urun, code]) => {
  SPECS[urun] = fx(urun, code);
});

const ALIASES = {
  "Cumhuriyet Ata 2.5'lu Gremse": "Cumhuriyet Ata 2.5'lu",
  'Cumhuriyet Ata Besli': 'Cumhuriyet Ata Beşli',
  "Reşat 2.5'lu Gremse": "Reşat 2.5'lu"
};

function decorate(spec) {
  if (!spec) return null;
  const effective = round4((spec.factor || 0) * (spec.extraFactor || 1));
  return {
    ...spec,
    multiplier: spec.kind === COST_KIND.COIN && spec.extraFactor === 1 ? spec.factor : effective,
    effectiveMultiplier: effective,
    hamLabel: HAM_LABEL[spec.hamCode] || spec.hamCode
  };
}

function round2(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

function round4(n) {
  return Math.round((Number(n) || 0) * 10000) / 10000;
}

export function listHamCatalogSpecs(kategori) {
  const wanted = normalizeProductName(kategori);
  return Object.values(SPECS)
    .filter((spec) => !wanted || spec.kategori === wanted)
    .map((spec) => decorate(spec));
}

export function listSarrafiyeZiynetSpecs() {
  return listHamCatalogSpecs('Sarrafiye').filter((spec) => spec.family === 'eski' || spec.family === 'yeni');
}

export function getHamCatalogSpec(product, islem) {
  const urun = normalizeProductName(islem?.urun || product?.isim || product?.urunTipi);
  if (!urun) return null;
  const canonical = ALIASES[urun] || urun;
  const spec = SPECS[canonical];
  if (!spec) return null;
  const kategori = normalizeProductName(product?.kategori || islem?.kategori);
  if (kategori && spec.kategori && kategori !== spec.kategori) return null;
  return decorate({ ...spec, urun: spec.urun || canonical });
}

export function getSarrafiyeZiynetSpec(product, islem) {
  const spec = getHamCatalogSpec(product, islem);
  if (!spec || (spec.family !== 'eski' && spec.family !== 'yeni')) return null;
  return spec;
}

export function applyHamRuleOverride(spec, rule) {
  if (!spec) return null;
  if (!rule) return spec;
  const hamCode = String(rule.hamCode || spec.hamCode || '').trim() || spec.hamCode;
  const factorRaw = toFiniteNumber(rule.hamMultiplier);
  const extraRaw = toFiniteNumber(rule.extraFactor);
  const milyemRaw = toFiniteNumber(rule.milyemOverride);
  return decorate({
    ...spec,
    hamCode,
    factor: factorRaw > 0 ? factorRaw : spec.factor,
    extraFactor: extraRaw > 0 ? extraRaw : spec.extraFactor,
    milyem: milyemRaw > 0 ? milyemRaw : spec.milyem
  });
}

function hamCodeFallbacks(code) {
  const upper = String(code || '').toUpperCase();
  if (upper === HAM_GRAM_24) return [HAM_GRAM_24, HAM_HAS];
  return [upper];
}

export function readHamSellTry(prices, code) {
  return readHamQuote(prices, code);
}

export function readHamQuote(prices, code) {
  let item = null;
  hamCodeFallbacks(code).some((tryCode) => {
    item = findPriceItem(prices, tryCode);
    return Boolean(item);
  });
  const sell = toFiniteNumber(item?.sell);
  const buy = toFiniteNumber(item?.buy);
  const resolved = String(item?.currencyCode || code || '').toUpperCase();
  return {
    code: resolved,
    sell,
    buy,
    ok: sell > 0 || buy > 0,
    label: HAM_LABEL[resolved] || resolved
  };
}

function quotePrice(quote, spec, side) {
  if (spec.quoteMode === 'buy') return quote.buy;
  if (spec.quoteMode === 'side') return side === 'buy' ? quote.buy : quote.sell;
  return quote.sell;
}

function emptyHam({ applicable = false, spec = null, adet = 0 } = {}) {
  return {
    applicable,
    ok: false,
    spec,
    quote: null,
    adet,
    gram: 0,
    unitCostTry: null,
    totalCostTry: null
  };
}

export function resolveHamCatalogCost({ product, islem, prices, rule } = {}) {
  const raw = getHamCatalogSpec(product, islem);
  if (!raw) return emptyHam();
  const spec = applyHamRuleOverride(raw, rule);
  const quote = readHamQuote(prices, spec.hamCode);
  const side = tradeSideOf(islem);
  const adetRaw = toFiniteNumber(islem?.adet);
  const adet = adetRaw > 0 ? adetRaw : 1;
  const gramRaw = toFiniteNumber(islem?.gram ?? product?.gram);
  const px = quotePrice(quote, spec, side);

  if (spec.kind === COST_KIND.MELT) {
    if (!(quote.buy > 0) || !(gramRaw > 0) || !(spec.milyem > 0)) {
      return { ...emptyHam({ applicable: true, spec, adet: gramRaw }), quote, gram: gramRaw };
    }
    const unitCostTry = round2(quote.buy * spec.milyem);
    const totalCostTry = round2(unitCostTry * gramRaw);
    return {
      applicable: true,
      ok: true,
      spec,
      quote,
      adet: gramRaw,
      gram: gramRaw,
      unitCostTry,
      totalCostTry
    };
  }

  if (!(px > 0)) {
    return { ...emptyHam({ applicable: true, spec, adet }), quote };
  }

  const unitCostTry = round2(px * spec.factor * spec.extraFactor);
  const totalCostTry = round2(unitCostTry * adet);
  return {
    applicable: true,
    ok: true,
    spec,
    quote,
    adet,
    gram: gramRaw,
    unitCostTry,
    totalCostTry
  };
}

export function resolveSarrafiyeZiynetCost({ product, islem, prices, rule } = {}) {
  const spec = getSarrafiyeZiynetSpec(product, islem);
  if (!spec) return emptyHam();
  return resolveHamCatalogCost({ product, islem, prices, rule });
}

export function previewHamUnitCost(spec, prices, { gram = 1, side = 'sale' } = {}) {
  if (!spec) return null;
  const quote = readHamQuote(prices, spec.hamCode);
  if (spec.kind === COST_KIND.MELT) {
    if (!(quote.buy > 0) || !(spec.milyem > 0)) return null;
    return round2(quote.buy * spec.milyem * (gram > 0 ? gram : 1));
  }
  const px = quotePrice(quote, spec, side);
  if (!(px > 0)) return null;
  return round2(px * spec.factor * spec.extraFactor);
}

export function tradeSideOf(islem) {
  return String(islem?.islemTuru || '').trim() === 'Alış' ? 'buy' : 'sale';
}

/**
 * Satış kârı = işlem tutarı − referans maliyet.
 * Alış kârı = referans maliyet − işlem tutarı.
 */
export function computeTradeEconomics({ amountTry, referenceCostTry, costComplete, side } = {}) {
  const amount = amountTry == null || amountTry === '' ? null : round2(toFiniteNumber(amountTry));
  if (costComplete !== true || referenceCostTry == null || amount == null) {
    return {
      amountTry: amount,
      referenceCostTry: costComplete === true ? referenceCostTry : null,
      grossProfitTry: null,
      grossMarginPct: null,
      side: side || 'sale'
    };
  }
  const cost = round2(toFiniteNumber(referenceCostTry));
  const profit = side === 'buy' ? round2(cost - amount) : round2(amount - cost);
  const marginBase = side === 'buy' ? cost : amount;
  const margin = marginBase > 0 ? Math.round((profit / marginBase) * 10000) / 100 : null;
  return {
    amountTry: amount,
    referenceCostTry: cost,
    grossProfitTry: profit,
    grossMarginPct: margin,
    side: side || 'sale'
  };
}
